import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import NProgress from '@/utils/progress'
import i18n from '@/i18n'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  // {
  //   path: '/',
  //   redirect: '/guide',
  //   meta: {
  //     requiresAuth: false,
  //     title: i18n.global.t('menu.guide'),
  //     icon: 'fas fa-compass',
  //     hidden: true,
  //   },
  // },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/LoginView.vue'),
    meta: {
      requiresAuth: false,
      title: i18n.global.t('menu.login'),
      hidden: true,
    },
  },
  {
    path: '/',
    redirect: '/guide',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      {
        path: 'guide',
        name: 'Guide',
        component: () => import('../views/guide/GuideView.vue'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('menu.guide'),
          hidden: false,
        },
      },
      {
        path: 'shipment',
        name: 'Shipment',
        component: () => import('../views/shipment/ShipmentView.vue'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('menu.shipment'),
          icon: 'fas fa-truck',
          hidden: false,
        },
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('../views/orders/OrdersView.vue'),
        children: [
          {
            path: '',
            name: 'OrderList',
            component: () => import('../views/orders/components/OrderList.vue'),
            meta: {
              requiresAuth: true,
              title: i18n.global.t('menu.orders'),
              icon: 'fas fa-clipboard-list',
              hidden: false,
            },
          },
          {
            path: ':id',
            name: 'OrderDetails',
            component: () =>
              import('../views/orders/components/OrderDetails.vue'),
            meta: {
              requiresAuth: true,
              title: i18n.global.t('menu.orderDetails'),
              hidden: true,
            },
          },
          {
            path: ':id/edit',
            name: 'OrderEditdetail',
            component: () =>
              import('../views/orders/components/OrderEditdetail.vue'),
            meta: {
              requiresAuth: true,
              title: i18n.global.t('menu.OrderEditdetail'),
              hidden: true,
            },
          },
        ],
      },
      {
        path: 'quote-history',
        name: 'QuoteHistory',
        component: () => import('@/views/quoteHistory/index.vue'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('menu.quoteHistory'),
          icon: 'fas fa-history',
          hidden: false,
        },
      },
      {
        path: 'addresses',
        name: 'Addresses',
        component: () => import('../views/addresses/AddressesView.vue'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('menu.addresses'),
          icon: 'fas fa-address-book',
          hidden: false,
        },
      },
      {
        path: 'customers',
        component: () => import('../views/customers/CustomersView.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          title: i18n.global.t('menu.customers'),
          icon: 'fas fa-users',
          hidden: false,
          requiresDistributor: true,
        },
        children: [
          {
            path: '',
            name: 'CustomerList',
            component: () =>
              import('../views/customers/components/CustomerList.vue'),
            meta: {
              requiresAuth: true,
              title: i18n.global.t('menu.customerList'),
              hidden: false,
              requiresDistributor: true,
            },
          },
          {
            path: ':id',
            name: 'CustomerDetails',
            component: () =>
              import('../views/customers/components/CustomerDetails.vue'),
            meta: {
              requiresAuth: true,
              title: i18n.global.t('menu.customerDetails'),
              hidden: true,
              requiresDistributor: true,
            },
          },
        ],
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('../views/contact/ContactView.vue'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('menu.contact'),
          icon: 'fas fa-envelope',
          hidden: false,
        },
      },
      {
        path: '/finance',
        name: 'finance',
        component: () => import('@/views/finance/FinanceView.vue'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('menu.finance'),
          icon: 'fas fa-wallet',
          hidden: false,
        },
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('../views/menu/index.vue'),
        meta: {
          requiresAuth: true,
          title: 'menu.menu',
          hidden: false,
        },
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('../views/role/index.vue'),
        meta: {
          requiresAuth: true,
          title: 'menu.role',
          hidden: false,
        },
      },
      {
        path: 'invoice',
        name: 'invoice',
        component: () => import('../views/invoice/index.vue'),
        meta: {
          requiresAuth: true,
          title: 'menu.invoice',
          hidden: false,
        },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/profile/ProfileView.vue'),
        meta: {
          requiresAuth: true,
          title: i18n.global.t('menu.profile'),
          hidden: true,
        },
      },
    ],
    meta: { requiresAuth: true },
  },
]

const router = createRouter({
  // history: createWebHashHistory(import.meta.env.BASE_URL),
  history: createWebHistory(), //import.meta.env.VITE_BASE_URL
  routes,
})

// 导航守卫
router.beforeEach((to, from, next) => {
  // const token = localStorage.getItem('auth_token')
  // const tokenExpiration = localStorage.getItem('auth_token_expiration')
  // const isTokenValid =
  //   token && tokenExpiration && Number(tokenExpiration) > Date.now() / 1000
  // const userRole = JSON.parse(localStorage.getItem('auth_user') || '{}').role
  NProgress.start()

  // 如果是带邀请码访问登录页，直接允许
  if (to.path === '/login' && to.query.code) {
    next()
    return
  }
  // 判断缓存是否存在用户，如果存在则说明已登录，如果不存在则说明未登录
  const isLoggedIn = !!localStorage.getItem('auth_user')
  // console.log(
  //   to.meta.requiresAuth && !isLoggedIn,
  //   to.path === '/login' && isLoggedIn && !to.query.code
  // )
  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !isLoggedIn) {
    localStorage.clear()
    next('/login')
  } else if (to.path === '/login' && isLoggedIn && !to.query.code) {
    next('/guide')
  } else if (to.meta.requiresDistributor && authStore.user?.userLevel === 2) {
    next('/guide')
  } else {
    next()
  }
})
router.afterEach(() => {
  NProgress.done()
})
export default router
